import 'consumerweb-shim';
import 'adsinterceptor';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Footer from 'marketing-components/dist/components/organisms/footer';
import Header from 'marketing-components/dist/components/organisms/header';
import {
  Link,
  ArrowLeftIcon,
  BodyText,
  CaptionText,
} from '@paypalcorp/pp-react';

import SearchBox from '../components/searchBox';
import CharityList from '../components/charityList';
import SearchSuggestion from '../components/searchSuggestion';
import styles from './searchPage.less';

import {
  HUB_PAGE_GROUP,
  HUB_PAGE_SEARCH_PAGE,
} from '../lib/fptiTrackingVariables';

import * as analytics from '../lib/analytics';

const containerStyle = {
  maxWidth: '1024px',
  margin: 'auto',
};

import content from '../lib/i18n';
const i18n = content('hubSearchPage');

if (window.PAYPAL && window.PAYPAL.analytics) {
  window.PAYPAL.analytics.startClientErrorTracking();
}

class Page extends React.Component {
  static propTypes = {
    csrf: PropTypes.string,
  };

  static childContextTypes = {
    csrf: PropTypes.string,
  };

  constructor(props, context) {
    super(props, context);

    var initialState = {
      isMobile: false,
      fptiInfo: {
        pgrp: HUB_PAGE_GROUP,
        page: HUB_PAGE_SEARCH_PAGE,
      },
    };
    this.state = initialState;
  }

  parseFPTIInfo = fptiData => {
    var nameValues = [];
    var pairs = decodeURIComponent(fptiData).split('&');
    var i;
    for (i = 0; i < pairs.length; i++) {
      var parts = pairs[i].split('=');
      nameValues[parts[0]] = parts[1];
    }
    return nameValues;
  };

  getChildContext() {
    return {
      csrf: this.props.csrf,
    };
  }

  componentDidMount() {
    let isMobile = false;
    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      isMobile = true;
      this.setState({
        isMobile,
      });
    }

    // to replace the default /signin href from marketing header
    // we need it to go back to npo page
    const marketingULButton = document.getElementById('ul-btn') || {};
    marketingULButton.href = this.props.unifiedLoginURL;
  }

  handleAnalyticsInviteLink = () => {
    analytics.trackLink(
      'PPGFInviteLink',
      this.state.fptiInfo.pgrp,
      this.state.fptiInfo.page,
      'link'
    );
  };

  renderHeader = () => {
    if (this.props.mppHeader) {
      const {
        content: { contentLoggedOut: content, config },
      } = JSON.parse(document.getElementById('data-header').innerHTML);

      const props = { content, config };
      return (
        <div className={'marketing-header-background'}>
          <Header {...props} />
        </div>
      );
    }
  };

  renderFooter = () => {
    const {
      content: { content: footerContent },
    } = JSON.parse(document.getElementById('data-footer').innerHTML);
    const { localeCountry } = footerContent;

    return (
      <Footer
        content={footerContent}
        localeCountry={localeCountry}
        flagHref={`https://www.${
          this.props.domain
        }/${localeCountry.toLowerCase()}/webapps/mpp/country-worldwide`}
      />
    );
  };

  render() {
    let noSearchResult = false;
    if (
      !Array.isArray(this.props.charities) ||
      this.props.charities.length === 0
    ) {
      noSearchResult = true;
    }
    const ppgfLink = (
      <p className={'vx_text-block'} style={{ margin: '0px 15px' }}>
        <CaptionText as='span' size='md'>
          {i18n('label.dont-see-fav-charity')}
        </CaptionText>
        <Link
          onClick={this.handleAnalyticsInviteLink}
          target={'_blank'}
          href={`${i18n('label.ppgf-link')}`}
        >
          &nbsp;{i18n('label.ppgf-text')}
        </Link>
      </p>
    );

    let result;
    let showCategory = !this.props.charityListUnderThreshold;
    if (noSearchResult) {
      result = (
        <SearchSuggestion
          {...this.props}
          i18n={i18n}
          fptiInfo={this.state.fptiInfo}
          noSearchResult={true}
          showCategory={showCategory}
          coBrand={`${coBrand}hub`}
        />
      );
    } else if (this.props.charities.length > 3) {
      result = (
        <CharityList
          {...this.props}
          fptiInfo={this.state.fptiInfo}
          i18n={i18n}
        />
      );
    } else {
      result = (
        <>
          <CharityList
            {...this.props}
            fptiInfo={this.state.fptiInfo}
            i18n={i18n}
          />
          {showCategory && (
            <SearchSuggestion
              {...this.props}
              i18n={i18n}
              fptiInfo={this.state.fptiInfo}
              noSearchResult={false}
              showCategory={showCategory}
              coBrand={`${coBrand}hub`}
            />
          )}
        </>
      );
    }
    return (
      <div>
        {this.renderHeader()}
        <div style={containerStyle}>
          <div className={styles.backNavContainer}>
            <Link
              href={'/fundraiser/hub'}
              leftIcon={<ArrowLeftIcon size='sm' />}
            >
              <BodyText className={styles.backNavText} strong>
                {i18n('label.back-nav')}
              </BodyText>
            </Link>
          </div>
          <div className={styles.searchBox}>
            <SearchBox
              {...this.props}
              i18n={i18n}
              isMobile={this.state.isMobile}
              fptiInfo={this.state.fptiInfo}
            />
          </div>
          {result}
          {noSearchResult || this.props.allowedCharityType === 'PPCC_DIRECT'
            ? undefined
            : ppgfLink}
          {this.props.mppFooter && this.renderFooter()}
        </div>
      </div>
    );
  }
}

const data = JSON.parse(document.getElementById('data-props').innerHTML);
const campaign = JSON.parse(
  document.getElementById('data-campaign').innerHTML || '{}'
);
const resources = JSON.parse(
  document.getElementById('data-resources').innerHTML
);
const charities = data.charities;
const suggestedCharties = data.suggestedCharties;
const allowedCharityType = data.allowedCharityType;
const states = data.states;
const categories = data.categories;
const query = data.query;
const labels = data.labels;
const csrf = document.getElementById('data-csrf').innerHTML;
const coBrand = document.getElementById('data-co-brand').innerHTML;
const fptiInfo = JSON.parse(
  document.getElementById('data-fpti-info').innerHTML
);
const charityUrl = `${coBrand}charity`;
const hubUrl = `${coBrand}hub`;
const searchUrl = document.getElementById('data-search-url').innerHTML;
const mppFooter = data.mppFooter;
const mppHeader = data.mppHeader;
const unifiedLoginURL = data.unifiedLoginURL;
const charityListUnderThreshold = data.charityListUnderThreshold;
const cdnHost = data.cdnHost;
const domain = data.domain;

ReactDOM.render(
  <Page
    query={query}
    charities={charities}
    suggestedCharties={suggestedCharties}
    allowedCharityType={allowedCharityType}
    categories={categories}
    fptiInfo={fptiInfo}
    states={states}
    labels={labels}
    coBrand={coBrand}
    csrf={csrf}
    searchUrl={searchUrl}
    charityUrl={charityUrl}
    resources={resources}
    hubUrl={hubUrl}
    campaign={campaign}
    mppFooter={mppFooter}
    mppHeader={mppHeader}
    charityListUnderThreshold={charityListUnderThreshold}
    unifiedLoginURL={unifiedLoginURL}
    cdnHost={cdnHost}
    domain={domain}
  />,
  document.getElementById('page')
);
